import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperComponent } from './stepper.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [StepperComponent],
  imports: [ CommonModule, SharedModule ],
  exports: [StepperComponent]
})
export class StepperModule { }
